import { SurveyEngine_Models_ApiResult, SurveyEngine_Models_SurveyInstance, SurveyEngine_Models_Command, SurveyEngine_Models_BaseResponse, SurveyEngine_Models_AuthenticateUserResponse, SurveyEngine_Models_CompletedResponse, SurveyEngine_Models_DispoSelectResponse, SurveyEngine_Models_DisqualifyResponse, SurveyEngine_Models_DynamicResponseResponse, SurveyEngine_Models_FileUploadResponse, SurveyEngine_Models_GetResponseResponse, SurveyEngine_Models_GetValueResponse, SurveyEngine_Models_MultiResponseResponse, SurveyEngine_Models_PlayValueResponse, SurveyEngine_Models_QualifyResponse, SurveyEngine_Models_RankingResponse, SurveyEngine_Models_RecordMessageResponse, SurveyEngine_Models_RecruitResponse, SurveyEngine_Models_ScaleMatrixResponse, SurveyEngine_Models_ScaleResponse, SurveyEngine_Models_SliderResponse, SurveyEngine_Models_StartGridResponse, SurveyEngine_Models_TerminateResponse, SurveyEngine_Models_VideoResponse, SurveyEngine_Models_WebCaptureResponse, SurveyEngine_Models_WebTransferResponse, SurveyService_Models_AnnounceResponse, SurveyService_Models_PanelistStudySchedule, SurveyEngine_Models_SessionCollection } from "../api";

export interface DispatchAction {
    type: string,
    value: any
  }

export enum ValidationErrorType {
  NO_ERROR,
  NO_RESPONSE,
  INVALID,
  RANGE
}
export interface validationError{
  commandType: string, 
  commandIndex: number
  errorType:ValidationErrorType
}
export type UserResponse  = Array<(SurveyEngine_Models_BaseResponse | SurveyService_Models_AnnounceResponse | SurveyEngine_Models_AuthenticateUserResponse | SurveyEngine_Models_CompletedResponse | SurveyEngine_Models_DispoSelectResponse | SurveyEngine_Models_DisqualifyResponse | SurveyEngine_Models_DynamicResponseResponse | SurveyEngine_Models_FileUploadResponse | SurveyEngine_Models_GetResponseResponse | SurveyEngine_Models_GetValueResponse | SurveyEngine_Models_MultiResponseResponse | SurveyEngine_Models_PlayValueResponse | SurveyEngine_Models_QualifyResponse | SurveyEngine_Models_RankingResponse | SurveyEngine_Models_RecordMessageResponse | SurveyEngine_Models_RecruitResponse | SurveyEngine_Models_ScaleMatrixResponse | SurveyEngine_Models_ScaleResponse | SurveyEngine_Models_SliderResponse | SurveyEngine_Models_StartGridResponse | SurveyEngine_Models_TerminateResponse | SurveyEngine_Models_VideoResponse | SurveyEngine_Models_WebCaptureResponse | SurveyEngine_Models_WebTransferResponse)>  
export interface SurveyState {
    IsLoading: boolean, 
    IsAPIError:boolean,
    APIError:SurveyEngine_Models_ApiResult,
    APIStatusCode : number,
    StartSurvey: SurveyEngine_Models_SurveyInstance,
    ProgressBarCounter: number,
    FirstCommandIndex:number,
    NextQuestion: SurveyEngine_Models_Command,
    IsComplete:boolean,
    ValidationErrors:validationError[],
    IsTimeOut:boolean,
    RedirectUrl:string,
    currentPanelistSchedule:SurveyService_Models_PanelistStudySchedule,
    AvailableSessions: SurveyEngine_Models_SessionCollection,
    panelistTimeZone: string 
  }  

   
  export interface GlobalState {
    StudyId: number,
    StudyIdentifier:string;
    PanelistId: number,
    PsGUID: string,
    UUID:string,
    Theme: string,
    Language: string,
    App:string,
    ForceRestart: boolean,
    LangResources: any,
    Header:Array<Header_Footer>,
    Footer:Array<Header_Footer>,
    PanelistToken:string,
    RedirectUrl:string
    DomainName:string
    PostSurvey:boolean
    isResourcesLoaded:boolean
  }  
export interface BlockState{
  isError:Boolean
  CurrentSumToValue:number
  currentIndex:number,
  resetFocus: boolean
}
export interface Header_Footer{
  key:string,
  value:string
  URL:string
}

export interface SelectedSession{
  sessionId:number,
  sessionName:string,
  sessionDay:string,
  sessionStartTime:string,
  sessionEndTime:string
  isOverFlow:boolean
  subSession?:Array<SelectedSession>
  isSessionAndCluster?:boolean
}


export interface RecruitState{
  selectedSessions:Array<SelectedSession>,
  currentState:ScheduleState,
  panelistOverAllStatus:string,
  clusterSelectionValidity:boolean
  recruitError:boolean
}
export enum ScheduleState {
  NONE,
  SCHEDULE,
  DECLINE,
  CONFIRM,
  POST_SURVEY_COMPLETED_DIALOG,
  POST_SURVEY_CONFIRM,
  POST_SURVEY_SCHEDULED,
  POST_SURVEY_CANCELLED,
  POST_SURVEY_CANCEL,
  POST_SURVEY_RESCHEDULE,
  POST_SURVEY_RESCHEDULE_CONFIRM
}
